module.exports = __webpack_public_path__ + "static/media/to-label.3f13c7cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/to-label.svg
// module id = 410
// module chunks = 0